export function getFileURL(id, version = 1) {
  switch (version) {
    case 1:
      return getFileURLV1(id);

    case 2:
      return getFileURLV2(id);

    default:
      throw new Error(`GetFileURL for version ${version} is not yet implemented.`);
  }
}

function getFileURLV1(id) {
  const host = process.env.VUE_APP_API_HOST;
  const apiPath = process.env.VUE_APP_API_PATH;

  return `${host}${apiPath}/upload/${id}`;
}

function getFileURLV2(id) {
  const host = process.env.VUE_APP_API_HOST;

  let fileURI = id;

  if (!fileURI) {
    return '';
  }

  if (!fileURI.startsWith('/')) {
    fileURI = `/${fileURI}`;
  }

  return id ? `${host}/api/v1/upload/v2${fileURI}` : '';
}
